import { createContext } from 'react';

import type { MovementInfo } from 'src/app/pages/movement/shared/api';

export const MovementContext = createContext<MovementInfo | null>(null);
